import React, { useContext } from 'react';
import { Typography, Card, Space, Avatar, Spin } from 'antd';
import { ApplicationUIContext, ButtonGroup } from '@yuhuinc/ui-library';
import { getTranslatedString } from 'helpers/i18n';
import { CurrentApplicationContext } from '../ApplicationOverview';
import { CardSectionTitle, CardContentWithDividers, StyledHeader } from '../common/Styles';
import Documents from '../application_overview/applicants/Documents';
import Insurance from '../application_overview/applicants/Insurance';
import { wipAction } from '../common/actions/WipModal';

const { Text } = Typography;

const translate = (key) =>
  getTranslatedString(`landlordPortal.applicationManagement.leaseOverview.${key}`);

const CardHeader = ({ title, secondary, avatar }) => {
  const { isMobile } = useContext(ApplicationUIContext);

  return (
    <Space gap={16}>
      <Avatar src={avatar} size={64} />
      <div>
        <CardSectionTitle style={{ marginBottom: isMobile ? 8 : 4 }}>{title}</CardSectionTitle>
        <Text type="secondary">{secondary}</Text>
      </div>
    </Space>
  );
};

const People = ({ selectedApplicantId }) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const currentApplication = useContext(CurrentApplicationContext);
  const canMarkAsSigned = true;
  const canEdit = true;

  const applicant = currentApplication?.applicants?.find(
    (applicant) => applicant.custom_id === selectedApplicantId
  );

  if (!applicant) {
    return <Spin />;
  }

  return (
    <Space direction="vertical" size={16} style={{ flex: 'auto', width: '100%' }}>
      <Card bodyStyle={{ padding: 16 }}>
        <StyledHeader style={{ alignItems: 'center' }}>
          <CardHeader
            title={applicant.full_name}
            secondary={getTranslatedString(
              `landlordPortal.applicationManagement.applicationOverview.overview.applicants.applicantTypes.${applicant.applicant_type}`
            )}
            avatar={applicant.avatar_url}
          />
          <ButtonGroup
            buttons={[
              canMarkAsSigned && {
                label: translate('people.buttons.markAsSigned'),
                key: 'markAsSigned',
                onClick: wipAction,
              },
              canEdit && {
                label: translate('people.buttons.edit'),
                key: 'edit',
                onClick: wipAction,
              },
            ].filter(Boolean)}
          />
        </StyledHeader>
      </Card>
      <Card>
        <CardContentWithDividers>
          <Documents />
          <Insurance />
        </CardContentWithDividers>
      </Card>
    </Space>
  );
};

export default People;
